import React, { lazy } from 'react';
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';

import {
  Button as MuiButton,
  Typography as MuiTypography
} from '@mui/material'
import { Icon } from 'components/ui'


const SwitchFilterButton = styled(({ isOpen, toSwitch, ...props }) => {
  const { t } = useTranslation();

  return (
    <MuiButton
      {...props}
      variant="contained"
      startIcon={
        <Icon icon="filter" color={isOpen ? 'primary' : 'secondary'} />
      }
      onClick={toSwitch}
    >
      <SMuiTypography variant="h3" color={isOpen ? 'primary' : undefined}>
        {t('Filters')}
      </SMuiTypography>
    </MuiButton>
  )
})`
  background-color: ${({theme}) => theme.palette.colors.white} !important;
  padding: 12px 24px;
  color: #000;
  width: 130px;
`

const SMuiTypography = styled(MuiTypography)`
  text-transform: none;
`

export default React.memo(SwitchFilterButton)
